export const AccommodationStatusIds = {
  APPROVED_TWP: 5,
  ASSOCIATE_REJECTED_TWP: 10,
  DENIED_TWP: 15,
  DLS_REFERRAL: 14,
  DLS_REFERRAL_RECEIVED: 22,
  INDEFINITE_RESTRICTIONS: 11,
  PLACEMENT_DECISION_PENDING: 1,
  PLOA: 8,
  PROVIDER_PLACED_OFF_WORK: 9,
  RETURN_TO_FULL_DUTY: 12,
  TWP_BUT_PENDING_UPDATED_RESTRICTIONS: 4,
} as const;
